<template>
  <div class="card">
    <div class="description text-center">
      <div class="line line-1  mb-3"></div>
      
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {}
  },
}
</script>
<style scoped>
body {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}
.card {
  width: 100%;
  background: transparent;
  padding: 00px;
  border-radius: 0px;
  border: none;
}

.description .line {
  background: #d9d9d9;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  opacity: 0.3;
}
.description .line-1 {
  height: 24px;
  width: 100%;
}
.description .line-3 {
  width: calc(100% - 40%);
}
.card .btns {
  display: flex;
}
.card .btns .btn {
  height: 45px;
  width: 100%;
  background: #d9d9d9;
  border-radius: 25px;
  position: relative;
  overflow: hidden;
}
.btns .btn-1 {
  margin-right: 8px;
}
.btns .btn-2 {
  margin-left: 8px;
}
.header .img::before,
.details span::before,
.description .line::before,
.btns .btn::before {
  position: absolute;
  content: '';
  height: 100%;
  width: 100%;
  background-image: linear-gradient(
    to right,
    #d9d9d9 0%,
    rgba(0, 0, 0, 0.07) 20%,
    #d9d9d9 40%,
    #d9d9d9 100%
  );
  background-repeat: no-repeat;
  background-size: 450px 400px;
  animation: shimmer 1s linear infinite;
}
.header .img::before {
  background-size: 650px 600px;
}
.details span::before {
  animation-delay: 0.2s;
}
.btns .btn-2::before {
  animation-delay: 0.22s;
}
@keyframes shimmer {
  0% {
    background-position: -450px 0;
  }
  100% {
    background-position: 450px 0;
  }
}
</style>
